import Axios, { AxiosRequestConfig, Canceler } from 'axios';

export interface GidAxiosRequestConfig extends AxiosRequestConfig {
  autoCancelScope: any;
}

export default class Api {
  static scopeMap: Map<any, Canceler> = new Map();

  static get(url: string, config?: GidAxiosRequestConfig) {
    config = this.prepareConfigAndAutoCancel(config);
    return this.wrapRequest(Axios.get(url, config), config);
  }

  static post(url: string, data?: any, config?: GidAxiosRequestConfig) {
    config = this.prepareConfigAndAutoCancel(config);
    return this.wrapRequest(Axios.post(url, data, config), config);
  }

  protected static prepareConfigAndAutoCancel(config?: GidAxiosRequestConfig) {
    if (config?.autoCancelScope) {
      this.scopeMap.get(config.autoCancelScope)?.('autocanceled');
      return {
        ...config,
        cancelToken: new Axios.CancelToken((cancel) => {
          this.scopeMap.set(config.autoCancelScope, cancel);
        }),
      };
    }
    return config;
  }

  protected static wrapRequest(request, config?: GidAxiosRequestConfig) {
    if (config?.autoCancelScope) {
      return new Promise((resolve, reject) => {
        request
          .then((response) => {
            this.deleteScope(config.autoCancelScope);
            resolve(response);
          })
          .catch((error) => {
            if (!Axios.isCancel(error)) {
              this.deleteScope(config.autoCancelScope);
              reject(error);
            }
          });
      });
    }
    return request;
  }

  private static deleteScope(scope) {
    this.scopeMap.delete(scope);
  }
}
